import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "trigger-logo"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "trigger-label" };
const _hoisted_4 = {
    key: 0,
    class: "trigger-value"
};
const _hoisted_5 = {
    key: 1,
    class: "trigger-placeholder"
};
const _hoisted_6 = { class: "drawer-content" };
const _hoisted_7 = { class: "subtitle-section" };
const _hoisted_8 = { class: "drawer-title" };
const _hoisted_9 = {
    key: 0,
    class: "drawer-subtitle"
};
const _hoisted_10 = {
    key: 0,
    class: "search-container"
};
const _hoisted_11 = { class: "items-list" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
    key: 0,
    class: "item-logo"
};
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
    key: 1,
    class: "logo-placeholder"
};
const _hoisted_16 = { class: "item-text" };
const _hoisted_17 = {
    key: 0,
    class: "no-results"
};
import { ref, computed } from 'vue';
import SimpleDrawerPanel from './SimpleDrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldDrawer',
    props: {
        modelValue: { default: null },
        label: {},
        items: { default: () => [] },
        subtitle: { default: null },
        notListedText: { default: null },
        placeholder: { default: null },
        required: { type: Boolean, default: false },
        clearable: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        showAvatars: { type: Boolean, default: true },
        theme: { default: 'light' }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const drawerOpen = ref(false);
        const searchQuery = ref('');
        const filteredItems = computed(() => {
            if (!searchQuery.value) {
                return props.items;
            }
            const query = searchQuery.value.toLowerCase();
            return props.items.filter((item) => {
                const text = getItemText(item).toLowerCase();
                return text.includes(query);
            });
        });
        const displayValue = computed(() => {
            const item = props.items.find((i) => getItemValue(i) === props.modelValue);
            return item ? getItemText(item) : props.modelValue;
        });
        const selectedLogo = computed(() => {
            if (!props.showAvatars || !props.modelValue)
                return null;
            const item = props.items.find((i) => getItemValue(i) === props.modelValue);
            return item ? getItemLogo(item) : null;
        });
        function getBrandLogoUrl(name) {
            if (!name)
                return require('@/assets/round3.png');
            const cleaned = cleanBrandName(name);
            return 'https://api.sysodev.link/BrandLogos/' + cleaned;
        }
        function cleanBrandName(name) {
            if (!name)
                return '';
            const map = { 'ø': 'o', 'Ø': 'O', 'æ': 'ae', 'Æ': 'AE', 'ß': 'ss', 'ð': 'd', 'Ð': 'D', 'þ': 'th', 'Þ': 'Th', 'đ': 'd', 'Đ': 'D', 'ł': 'l', 'Ł': 'L' };
            let ret = name.replace(/[ /]/g, '+');
            ret = ret.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x20-\x7E]/g, function (c) { return map[c] || ''; });
            ret = encodeURIComponent(ret);
            return ret;
        }
        function getItemText(item) {
            if (typeof item === 'string')
                return item;
            return item.text || item.name || item.label || '';
        }
        function getItemValue(item) {
            if (typeof item === 'string')
                return item;
            return item.value !== undefined ? item.value : (item.name || item.text || item.label);
        }
        function getItemLogo(item) {
            if (typeof item === 'string')
                return getBrandLogoUrl(item);
            if (item.logoUri || item.logo || item.icon)
                return item.logoUri || item.logo || item.icon;
            const name = getItemText(item);
            if (name)
                return getBrandLogoUrl(name);
            return null;
        }
        function handleLogoError(event) {
            event.target.src = require('@/assets/round1.png');
        }
        function openDrawer() {
            if (props.disabled)
                return;
            searchQuery.value = '';
            drawerOpen.value = true;
        }
        function selectItem(item) {
            const value = getItemValue(item);
            emit('update:modelValue', value);
            setTimeout(() => {
                drawerOpen.value = false;
            }, 200);
        }
        function clearValue() {
            emit('update:modelValue', null);
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["field-drawer-trigger", { disabled: _ctx.disabled }]),
                    onClick: openDrawer
                }, [
                    (selectedLogo.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("img", {
                                src: selectedLogo.value,
                                alt: displayValue.value,
                                onError: handleLogoError
                            }, null, 40, _hoisted_2)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass(["trigger-content", { 'has-value': _ctx.modelValue }])
                    }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label) + " " + _toDisplayString(_ctx.required && !_ctx.disabled ? '*' : ''), 1),
                        (_ctx.modelValue)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(displayValue.value), 1))
                            : (_ctx.placeholder)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.placeholder), 1))
                                : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.modelValue && _ctx.clearable)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            class: "trigger-clear",
                            onClick: _withModifiers(clearValue, ["stop"])
                        }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("mdi-close")
                            ])),
                            _: 1
                        }))
                        : (!_ctx.disabled)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 2,
                                class: "trigger-chevron"
                            }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("mdi-chevron-down")
                                ])),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                ], 2),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: drawerOpen.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((drawerOpen).value = $event)),
                    title: _ctx.label,
                    divider: false,
                    closeButton: true,
                    height: "85vh"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.subtitle || 'Choose a ' + _ctx.label.toLowerCase()), 1),
                                (_ctx.notListedText)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.notListedText), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            (_ctx.items.length > 5)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(_component_v_icon, { class: "search-icon" }, {
                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode("mdi-magnify")
                                        ])),
                                        _: 1
                                    }),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                        placeholder: "Search",
                                        class: "search-input",
                                        ref: "searchInput"
                                    }, null, 512), [
                                        [_vModelText, searchQuery.value]
                                    ]),
                                    (searchQuery.value)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "search-clear",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (searchQuery.value = ''))
                                        }, {
                                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                _createTextVNode("mdi-close")
                                            ])),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: getItemValue(item),
                                        class: _normalizeClass(["item-card", { selected: getItemValue(item) === _ctx.modelValue }]),
                                        onClick: ($event) => (selectItem(item))
                                    }, [
                                        (_ctx.showAvatars)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                (getItemLogo(item))
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: getItemLogo(item),
                                                        alt: getItemText(item),
                                                        onError: handleLogoError
                                                    }, null, 40, _hoisted_14))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                        _createElementVNode("span", null, _toDisplayString(getItemText(item).charAt(0).toUpperCase()), 1)
                                                    ]))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(getItemText(item)), 1),
                                        (getItemValue(item) === _ctx.modelValue)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                class: "item-check"
                                            }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                    _createTextVNode("mdi-check")
                                                ])),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ], 10, _hoisted_12));
                                }), 128)),
                                (filteredItems.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, " No results found "))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ], 64));
        };
    }
});
